/** Kind of document file template key (how the value is resolved for DOCX substitution) */
export enum DocumentFileTemplateKeyKindEnum {
  /** Value is taken from deal (or related) by `target` path */
  ORDINARY = 'ORDINARY',
  /** Value is the Russian amount-in-words for the numeric value of another key */
  AMOUNT_IN_WORDS = 'AMOUNT_IN_WORDS',
}
